const withdrawPage = `plus_withdrawpage(uid: "blt94806203232120cf") {
    title
    learn_more_text
    request {
      button_text
      daily_limit_text
      pounds_only_text
      text
      title
    }
    info_modal {
      button_text
      header
      text
    }
    restrictions {
      accept_button_text
      back_button_text
      header
      more_text
      pin {
        header
        button_text
        text
      }
      text
      title
    }
}`;

export default withdrawPage;
